import React, { FC } from "react";
import { Banner } from "@/components/Banners/Banner";
import { ListDotted } from "@/components/LandingResources/ListDotted";
import { cssListDottedImage, StyledListDottedImageContainer } from "@/components/LandingResources/ListDotted/StyledListDotted";
import { ListDottedImagePropsType } from "@/components/LandingResources/ListDotted/types";
const ListDottedImage: FC<ListDottedImagePropsType> = ({
  image
}) => {
  return <StyledListDottedImageContainer>
      <Banner image={{
      desktop: {
        src: image,
        objectFit: "cover",
        layout: "fill"
      }
    }} withFormatUrl={false} className={cssListDottedImage} />
      <ListDotted />
    </StyledListDottedImageContainer>;
};
export { ListDottedImage };